<template>
  <div>
    <component v-if="isActive" v-bind:is="dynamicComponent"></component>
  </div>
</template>

<script>
const PreviewEvent = () => import('@/components/popups/previewEventInfoPopup');
const PreviewShop = () => import('@/components/popups/previewShopInfoPopup');
const PreviewOffer = () => import('@/components/popups/previewOfferInfoPopup');

export default {
  name: "preview-popup",
  components: {
    'preview-event': PreviewEvent,
    'preview-shop': PreviewShop,
    'preview-offer': PreviewOffer,
  },
  computed: {
    dynamicComponent() {
      return this.$store.state.popupPreviewName;
    },
    isActive() {
      return this.dynamicComponent !== '';
    }
  }
};
</script>
